import { IconTrash } from '@consta/icons/IconTrash'
import { Button } from '@consta/uikit/Button'
import { TextField } from '@consta/uikit/TextField'
import { TreeInput } from '@core/components'
import { selectActiveEntityColor, useAppSelector } from '@core/core/store'
import type { BaseEntity } from '@core/core/types'
import type { BaseObject, Nullable } from 'common/types'
import type { FC } from 'react'

import css from './MapBuildingRightMenu.css'
import type { SelectItemProps } from './types'

const allowedTypes: BaseObject[] = ['interpretation3D', 'interpretation2D', 'horizon']

export const SelectItem: FC<SelectItemProps> = ({
  addSelectItem,
  deleteSelectItem,
  clearSelectItemValue,
  onChangeHorizonWeight,
  formData,
  item,
  itemsLength,
}) => {
  const { color, value } = item
  const activeEntityColor = useAppSelector(selectActiveEntityColor)
  const sources = formData.buildInfo.sources
  const weight =
    sources.interpretations2d.find(i => i.id === value?.entityId)?.weight ??
    sources.interpretations3d.find(i => i.id === value?.entityId)?.weight ??
    sources.horizons.find(i => i.id === value?.entityId)?.weight ??
    1
  const onChangeTreeInput = (value: Nullable<BaseEntity>) => {
    if (value) {
      addSelectItem(value, activeEntityColor)
    } else {
      clearSelectItemValue()
    }
  }

  return (
    <div className={`${css.selectItemContainer} ${css.selectItem}`}>
      <div className={css.treeInput}>
        <TreeInput
          value={value}
          allowedTypes={allowedTypes}
          tooltip="Импорт из дерева"
          color={color}
          onChange={onChangeTreeInput}
        />
      </div>
      <TextField
        className={css.selectItemMenuFields}
        size="xs"
        placeholder="Вес"
        type="number"
        disabled={!value}
        value={`${weight}`}
        max="1"
        min="0"
        step={0.1}
        onChange={num => {
          if (value?.entityId) {
            onChangeHorizonWeight(value.entityId, Number(num))
          }
        }}
      />
      {itemsLength !== 1 && (
        <Button
          className={css.deleteButton}
          size="xs"
          view="clear"
          iconLeft={IconTrash}
          onClick={deleteSelectItem}
        />
      )}
    </div>
  )
}
